import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './dialog';
import { Button } from './button';
import { Input } from './input';
import { Label } from './label';
import { normalizarEnlace } from '../../lib/enlaces';

/**
 * Pedir la dirección de un enlace (M27): sustituye a window.prompt, que no sigue el tema, no se
 * puede leer bien en el móvil y no validaba nada. Quien lo usa guarda la selección del editor
 * antes de abrirlo (el diálogo se lleva el foco) y la repone en `onAceptar`.
 */
export function DialogoEnlace({ open, onOpenChange, onAceptar }) {
  const [valor, setValor] = useState('');
  const [error, setError] = useState(null);
  useEffect(() => { if (open) { setValor(''); setError(null); } }, [open]);

  const aceptar = (e) => {
    e?.preventDefault();
    const url = normalizarEnlace(valor);
    if (!url) { setError('Escribe una dirección web (orvian.mx) o un correo (ana@empresa.mx).'); return; }
    onOpenChange(false);
    onAceptar(url);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[420px]" data-testid="dialogo-enlace">
        <form onSubmit={aceptar} className="space-y-3">
          <DialogHeader>
            <DialogTitle>Insertar enlace</DialogTitle>
            <DialogDescription style={{ color: 'var(--text-2)' }}>
              Si seleccionaste texto, ese texto será el enlace.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-1.5">
            <Label htmlFor="enlace-url">Dirección</Label>
            <Input
              id="enlace-url"
              autoFocus
              value={valor}
              onChange={(e) => { setValor(e.target.value); setError(null); }}
              placeholder="https://…"
              inputMode="url"
              autoCapitalize="none"
              autoCorrect="off"
              aria-invalid={!!error}
              aria-describedby={error ? 'enlace-error' : undefined}
            />
            {error && <p id="enlace-error" role="alert" className="text-sm" style={{ color: 'var(--danger)' }}>{error}</p>}
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
            <Button type="submit">Insertar</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
